<script setup lang="ts">
import { computed } from 'vue';
// import AppFooter from './AppFooter.vue';
import SiteTopbar from './SiteTopbar.vue';
// import AppSidebar from "@/layout/AppSidebar.vue";


const containerClass = computed(() => {
    return {
        'layout-overlay': false,
        'layout-static': true,
        'layout-static-inactive': true,
        'layout-overlay-active': false,
        'layout-mobile-active': false
    };
});
</script>

<template>
    <div class="layout-wrapper" :class="containerClass">
        <site-topbar></site-topbar>
<!--        <app-sidebar></app-sidebar>-->
        <div class="layout-main-container">
            <div class="layout-main">
                <router-view></router-view>
            </div>
        </div>
        <div class="layout-mask animate-fadein"></div>
    </div>
    <Toast />
</template>
